import styles from "./QuickMenu.module.css";
import React, { Component } from "react";

export default class QuickMenuCard extends Component {
  // adjustFontSize = (name) => {
  //   return name.length > 10 ? "long-text" : "";
  // };
 

  render() {
    console.log("QuickMenuCard Props:", this.props)

    let buttons = this.props.buttons.map((item, i) => (
      <button
        onClick={(e) => {
          e.preventDefault();
          if (item.target === "workflow") {
            this.props.onTriggerWorkflow(item.targetId, item.name, item.target);
  
          } else if (item.target === "faqmenu") {
            this.props.onCallFaqMenu(item.targetId, item.name, item.target);
          } else if (item.target === "upcoming") {
            this.props.onCallUpcomingMessage(item.targetId, item.name, item.target);
          } else {
            this.props.onCallback(item.url);
          }
        }}
        className={styles.menu_button}
        key={i}
      >
        <img src={item.img} alt="button image" className={styles.button_image} />
        {/* <span className={styles.button_item_name} >{item.name}</span> */}
        <span style={{fontSize:this.props.onfontSize ==="medium"?"10px":"11px"}}>
          {item.name}
        </span>
      </button>
    ));
    return <div className={styles.button_container}>
    <div className={styles.button}>{buttons}

    </div>
  </div>
  }
}
